// extracted by mini-css-extract-plugin
export var bodyContent = "styles-module--bodyContent--ee58c";
export var cardTitles = "styles-module--cardTitles--905ce";
export var left = "styles-module--left--072d5";